import React, { Component } from 'react';

import { Copy, Label, Paragraph, Button } from '../../theme';

import { Mecanism as MecansimSvg } from '../../svg';

class CampaignMecanism extends Component {
    render() {
        return (
            <div id="CampaginMecansim" className="container__fluid mecansim">
                <div className="w__flex w__flex-column Justify-between Align-center">

                    <div className="cell">
                        <Label marginRight="0vw" background="#840050" >
                            mecanismul campaniei
                            </Label>
                        <Copy normal alignRight padding="0vw" >
                            <span>Schimba doua lucruri</span>
                            <span>cu o singura mutare!</span>
                        </Copy>
                    </div>

                    <div className="feature o-2__mobile">
                        <MecansimSvg.Feature />
                    </div>

                    <div className="cell">
                        <Paragraph large alignLeft padding="15vw">
                            CUMPARA UN ELECTROCASNIC ARCTIC SI ENEL ITI OFERA 15% REDUCERE
                            <br className="mobile__hidden" />
                            LA ENERGIE CU ABONAMENTUL ENEL FIX RELAXAT*
                        </Paragraph>
                        <Paragraph normal alignLeft padding="15vw">
                            *Promotia se aplica la achizitionarea oricarui produs Arctic din categoriile frigidere, masini de spalat
                            <br className="mobile__hidden" />
                            rufe, masini de spalat vase, plite, cuptoare, aragaze, in perioada 16 august - 31 decembrie 2018.
                        </Paragraph>
                    </div>

                    <div style={{ zIndex: 1005 }} className="Self-start o-3__mobile">
                        <Button enel >
                            <span className="mobile__hidden">Vezi</span>  oferta enel
                        </Button>
                        <a href={require('../../../assets/regulament.pdf')} target="_blank" rel="noopener noreferrer" className="btn regulament">
                            <span>
                                <span><span className="mobile__hidden">Vezi</span>  regulament</span>
                                <img alt="arrow right" src={require('../../../assets/img/icons/pointer-regulament.svg')} />
                            </span>
                        </a>
                    </div>

                </div>
            </div>
        );
    }
}

export default CampaignMecanism;


// WEBPACK FOOTER //
// ./src/components/pages/Mecanism/CampaignMecansim.jsx